<template>
  <div
    v-if="open"
    class="overlay"
    role="dialog"
    aria-modal="true"
    @keydown.esc="emitClose"
  >
    <div
      ref="panel"
      class="dialog"
      :style="{ width: `min(${props.maxWidth}, calc(100vw - 24px))` }"
    >
      <header class="dialog-header">
        <h2 class="h2">
          <slot name="title">
            Dialog
          </slot>
        </h2>
        <button
          class="btn"
          :disabled="disabled"
          aria-label="Schließen"
          @click="emitClose"
        >
          <svg
            class="icon-close"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M6 6L18 18M18 6L6 18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </header>
      <section
        class="dialog-body"
        :style="{ maxHeight: props.bodyMaxHeight || undefined, overflowY: props.bodyMaxHeight ? 'auto' : undefined }"
      >
        <slot />
      </section>
      <footer class="dialog-footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from 'vue';

const props = defineProps({
  open: {type: Boolean, default: false},
  disabled: {type: Boolean, default: false},
  maxWidth: {type: String, default: '640px'},
  bodyMaxHeight: {type: String, default: null}
});
const emit = defineEmits(['close']);
const panel = ref(null);

function emitClose() {
  emit('close');
}

watch(() => props.open, (val) => {
  if (val) {
    setTimeout(() => {
      const el = panel.value?.querySelector('input,select,textarea,button');
      el?.focus();
    }, 0);
  }
});
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .35);
  display: grid;
  place-items: center;
  z-index: 1000;
}

.dialog {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-1);
  /* width kommt jetzt dynamisch über :style */
  max-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
}

.dialog-header, .dialog-footer {
  padding: 12px 16px;
}

.dialog-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
}

.dialog-body {
  padding: 16px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .dialog-body {
    overflow: auto;
  }
}

.h2 {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin: 0;
}

.icon-close {
  display: block;
  color: var(--muted);
}
</style>
